import first from 'lodash/first';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { getDefaultSportsOrder, getSportsOrderMap } from '@/composable/sportsOrderConfig';
import { SportType } from '@/interface/enum';
import { useCustomerStore } from '@/store/customerStore';
import { useToggleStore } from '@/store/toggleStore';

export function useSportsOrder() {
    const { sboCurrency } = storeToRefs(useCustomerStore());
    const { defaultSportType: _defaultSportType } = storeToRefs(useToggleStore());

    const sportsOrderMap = getSportsOrderMap();
    const defaultSportsOrder = getDefaultSportsOrder();
    const sportsOrder = computed(() => {
        const currencyOrder = sportsOrderMap[sboCurrency.value] ?? defaultSportsOrder;
        return [
            _defaultSportType.value,
            ...currencyOrder.filter(sport => sport !== _defaultSportType.value),
        ];
    });

    const defaultSportType = computed(() => first(sportsOrder.value) ?? SportType.Soccer);

    return {
        sportsOrder,
        defaultSportType,
    };
}
